import BaseValidator from 'ember-cp-validations/validators/base';

export default BaseValidator.extend({
  validate(value, options, model) {
    let variants = model.variants;
    variants = variants.filter((variant) => {
      return variant?.variantChannel?.id === model?.variantChannel?.id;
    });

    let duplicates = variants.filter(
      (variant) => variant.cmsLanguageId == value,
    );

    if (duplicates.length > 0) {
      return this.createErrorMessage('unique-language-variant', value, options);
    }

    return true;
  },
});
